export const personalInfo = {
  name: "Abin Shoby",
  photo: "./profile.jpg",
  logo: "./logo.png",
  address: "8 Daly Street, South Plympton, SA 5038, Australia",
  phone: "+61 424 246 185",
  email: "abinshoby@gmail.com",
  github: "https://github.com/abinshoby",
  linkedin: "https://linkedin.com/in/abinshoby",
  resume_pdf: "https://abinshoby.netlify.app/Resume.pdf",
  objective:
    "An Artificial Intelligence researcher who loves solving socially relevant challenges through expertise in AI & ML, and further enhancing my research skills and professional growth.",
};

export const education = [
  {
    school: "The University of Adelaide",
    degree: "Master of Artificial Intelligence and Machine Learning",
    location: "Adelaide, Australia",
    date: "Jan 2024 – Dec 2025",
    grade: "6.909 / 7",
  },
  {
    school: "TKM College of Engineering",
    location: "Kollam, Kerala, India",
    degree: "B.Tech (Hons) in Computer Science and Engineering",
    affiliation: "APJ Abdul Kalam Technological University, Kerala, India",
    date: "Aug 2016 – May 2020",
    grade: "9.36 / 10",
  },
  {
    school: "St. Antony's Public School",
    location: "Anakkal, Kerala, India",
    degree: "Senior Secondary Education",
    affiliation: "Central Board of Secondary Education (CBSE), India",
    date: "May 2014 – May 2016",
    grade: "94%",
  },
  {
    school: "De Paul Public School",
    location: "Kalpetta, Kerala, India",
    degree: "Secondary Education",
    affiliation: "Central Board of Secondary Education (CBSE), India",
    date: "June 2009 - May 2014",
    grade: "10 / 10",
  },
   {
    school: "St. Joseph's Convent School",
    location: "Kalpetta, Kerala, India",
    degree: "Primary School",
    affiliation: "Central Board of Secondary Education (CBSE), India",
    date: "June 2002 - 2009 March"
  },
];

export const experience = [
  {
    title: "Research Officer",
    company: "<em>Australian Institute for Machine Learning (AIML), Adelaide, Australia</em>",
    startDate: "2026-01-27",
    endDate: "Present",
    date: "Jan 2026 – Present",
    details: [
      "Analysed the neural network architecture and reduced demographic TPR disparity by more than 90%.",
      "Finding new methods to mitigate <strong>demographic bias</strong> in medical AI Models.",
      "Extracted, deidentified and managed data for researchers.",
      "Developed a PACS data extraction tool."
    ],
  },
  {
    title: "Data Analyst Specialist / Machine Learning Engineer",
    company: "<em>Crohn's Colitis Cure, Adelaide, Australia</em>",
    startDate: "2026-01-27",
    endDate: "Present",
    date: "Jan 2026 – Present",
    details: [
      "Analysing medical data for the Crohn's Colitis Cure organisation to find insights for better treatment and care.",
      "Extracting and transforming (<strong>ETL</strong>) medical data using <strong>SQL</strong>.",
      "Developed and enhanced the IBD Perfect <strong>Power BI</strong> dashboard for QA and clinical benchmarking.",
      "Statistical analysis of data for clinical research."
    ],
  },
  {
    title: "Machine Learning Research Intern",
    company: "<em>Australian Institute for Machine Learning (AIML), Adelaide, Australia</em>",
    startDate: "2025-01-13",
    endDate: "2025-04-18",
    date: "Jan 2025 – Apr 2025",
    details: [
      "Analysed and finetuned <strong>Multimodal Large Language Models (MLLMs)</strong> for medical report generation, zero-shot classification, regression, and segmentation.",
      "The work was published in <strong>MICCAI 2025</strong> conference.",
    ],
  },
  {
    title: "AI Trainer (Part-time)",
    company: "<em>Outlier.ai, Remote</em>",
    startDate: "2024-02-01",
    endDate: "Present",
    date: "Feb 2024 – Present",
    details: [
      "Training and evaluating <strong>LLMs</strong>, <strong>code analysis</strong>, and <strong>prompt engineering</strong>.",
    ],
  },
  {
    title: "AI Trainer (Part-time)",
    company: "<em>DataAnnotation.Tech, Remote</em>",
    startDate: "2024-02-01",
    endDate: "2024-12-31",
    date: "Feb 2024 – December 2024",
    details: [
      "Training and evaluating <strong>LLMs</strong>, <strong>code analysis</strong>, and <strong>prompt engineering</strong>.",
    ],
  },
  {
    title: "Systems Engineer",
    company: "<em>TATA Consultancy Services, Kochi, India</em>",
    startDate: "2020-09-24",
    endDate: "2024-01-30",
    date: "Sep 2020 – Jan 2024",
    details: [
      "Acted as the <strong>tech lead</strong> for JAMstack web development projects.",
      "Proposed a novel <strong>JAMstack</strong> architecture using <strong>Drupal</strong> & <strong>Next.js</strong>.",
      "Delivered 7 websites in an year for the US-based client."
    ],
  },
  {
    title: "Software Development Intern",
    company: "<em>CLAP Research Private Ltd, Thiruvananthapuram, India</em>",
    startDate: "2019-06-19",
    endDate: "2019-07-29",
    date: "Jun 2019 - Jul 2019",
    details: [
        "Designed a sports website for a client.", 
        "Developed a tool for PDF data extraction."
    ],
  },
  {
    title: "Machine Learning Intern",
    company: "<em>ICFOSS, Thiruvananthapuram, India</em>",
    startDate: "2018-07-01",
    endDate: "2018-07-27",
    date: "Jul 2018",
    details: [
        "Designed an <strong>LSTM</strong> network for Malayalam question suggestion application.",
        "The work was accepted for the research poster presentation at the <strong>ACM Compute 2018</strong> conference.",
        "Developed a Malayalam WordNet using <strong>Selenium</strong> and web scraping tools."
    ],
  },
];

export const publications = [
    {
    title: "Neuron Incidence Redistribution for Fairness in Medical Image Classification",
    authors: ["Abin Shoby", "Lyle J. Palmer", "Nikhil Cherian Kurian"],
    journal: "IEEE International Conference on Responsible Artificial Intelligence (RAI), IEEE, Melbourne, Australia.",
    date: "2026",
    summary: "Discovered that any single neuron at the penultimate layer of ResNet-18 <strong>polysemantically</strong> encodes disease labels and demographic information, resulting in biased predictions. A <strong>Neuron Incidence Redistribution (NIR)</strong> loss was proposed to achieve more than 90% TPR disparity reduction in the HAM10000 dataset.",
    link: "https://arxiv.org/abs/2605.19393"
  },
  {
    title: "Robust Mitigation of Age-Dependent Confounding Effects via Sample-Difficulty Decorrelation",
    authors: ["Nikhil Cherian Kurian", "Victor Caquilpan Parra", "Abin Shoby", "Luke Whitbread", "Lyle J. Palmer"],
    journal: "Proceedings of Medical Image Computing and Computer Assisted Intervention (MICCAI)",
    date: "2026",
    summary: "Proposed a fairness framework for medical image classification that reduces age-driven diagnostic disparities by decorrelating age from dominant age-difficulty trends and shows that across two radiology datasets it reduces age-dependent disparities with minimal AUC impact and remains robust to train–test age distribution shifts.",
    link: "https://arxiv.org/abs/2605.19230"
  },
  {
    title: "Overthinking Causes Hallucination: Tracing Confounder Propagation in Vision Language Models",
    authors: ["Abin Shoby", "Ta Duc Huy", "Tuan Dung Nguyen", "Minh Khoi Ho", "Qi Chen", "Anton van den Hengel", "Phi Le Nguyen", "Johan W. Verjans", "Vu Minh Hieu Phan"],
    journal: "Proceedings of the IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR)",
    date: "2026",
    summary: "First paper to analyze the layer-wise thought process of VLMs and identify \"overthinking\" as a key factor in hallucination, leading to a novel hallucination detection method with significant performance improvements.",
    link: "https://openaccess.thecvf.com/content/CVPR2026F/papers/Shoby_Overthinking_Causes_Hallucination_Tracing_Confounder_Propagation_in_Vision_Language_Models_CVPRF_2026_paper.pdf"
  },
  {
    title: "PedCLIP: A Vision-Language model for Pediatric X-rays with Mixture of Body part Experts",
    authors: ["Ta Duc Huy", "Abin Shoby", "Sen Tran", "Yutong Xie", "Qi Chen", " Phi Le Nguyen", "Akshay Gole", "Lingqiao Liu", "Antonios Perperidis", "Mark Friswel", "Rebecca Linke", "Andrea Glynn", "Minh-Son To", "Anton van den Hengel", "Johan Verjans", "Zhibin Liao", "Minh Hieu Phan"],
    journal: "Proceedings of Medical Image Computing and Computer Assisted Intervention (MICCAI), Springer Nature, Switzerland.",
    date: "2025",
    summary: "A novel Pediatric Vision-Language Model (VLM) was developed using a mixture of body part expert design for medical report generation and zero-shot classification, regression, and segmentation.",
    link: "https://doi.org/10.1007/978-3-032-04971-1_46"
  },
  {
    title: "A Novel Deep Learning Approach for b-value Optimisation in Intravoxel Incoherent Motion Magnetic Resonance Imaging on Simulated Data",
    authors: ["Abin Shoby", "Jerome Francis", "Jini Raju", "Ansamma John", "Ushadevi Amma C"],
    journal: "International Journal of Medical Engineering and Informatics",
    date: "2026",
    summary: "A Bi-LSTM network was developed to reconstruct IVIM MRI images and optimise the MRI acquisition time.",
    link: "https://doi.org/10.1504/ijmei.2026.154136"
  },
];

export const projects = [
    {
    title: "Neuron Incidence Redistribution for Fairness in Medical Image Classification",
    date: "Mar 2026",
    description:
      "Discovered that any single neuron at the penultimate layer of ResNet-18 <strong>polysemantically</strong> encodes disease labels and demographic information, resulting in biased predictions. A <strong>Neuron Incidence Redistribution (NIR)</strong> loss was proposed to achieve more than 90% TPR disparity reduction in the HAM10000 dataset.",
    results: [
      ],
      repo: "https://github.com/abinshoby/neuron-incidence-redistribution"
    },
    {
    title: "Overthinking Causes Hallucination: Tracing Confounder Propagation in Vision Language Models",
    date: "Apr 2025",
    description:
      "Analyzed the layer-wise thought process of <strong>Vision-Language Models (VLMs)</strong> and found <strong>\"overthinking\"</strong> as a key factor in hallucination, leading to a novel <strong>hallucination detection</strong> method with significant performance improvements. The work is accepted in the findings section of the <strong>CVPR (2026)</strong> conference.",
    results: [
      "f1-score on MSCOCO Dataset: 78.90%",
      "f1-score on AMBER Dataset: 71.58%",
      ],
    repo: "https://github.com/abinshoby/Overthinking"
    },
    {
    title: "Grocery Recommendation System",
    date: "Apr 2025",
    description:
      "Developed a grocery <strong>recommendation system</strong> using a hybrid of <strong>Apriori</strong> and <strong>KNN</strong> algorithms.",
    results: [
            "f1@5: 97.42%"
        ],
    repo: "https://github.com/abinshoby/Grocery-Recommendation-System"
    },
    {
    title: "PedCLIP: A Vision-Language Model for Pediatric X-rays with Mixture of Body Part Experts",
    date: "Jan 2025",
    description:
      "Collaborated on developing a novel <strong>VLM</strong> using a mixture of body part expert design for medical report generation, zero-shot classification, regression, and segmentation during my internship at AIML, Adelaide.",
    results: [
            "Accepted for the <strong>MICCAI 2025</strong> conference."
        ],
    repo: "https://github.com/abinshoby/MedLLM"
    },
     {
    title: "DivisiveNet for American Sign Language Classification",
    date: "Nov 2024",
    description:
      "Developed a novel <strong>CNN</strong> architecture - DivisiveNet for American Sign Language Classification.",
    results: [
            "Performs better than AlexNet, ResNet-18 and MobileNet-V2",
            "Accuracy: 96.43%",
            "f1-score: 96.41%",
            "Parameters: 3.8M"
        ],
    repo: "https://github.com/abinshoby/DivisiveNet"
    },
    {
    title: "EyesOnGenes.com JAMstack Website",
    date: "Jan 2023",
    description:
      "Collaborated with my colleagues at TATA Consultancy Services, India, to build a novel <strong>JAMstack</strong> architecture using <strong>Next.js</strong> and <strong>Drupal</strong> for the fast-paced development of 7 variants of EyesOnGenes.com website.",
    results: [
            "Delivered 7 websites in an year."
        ],
    demo: "https://www.eyesongenes.com/"
    },
  {
    title: "IVIM MRI Image Reconstruction",
    date: "Sep 2019",
    description:
      "Reconstructed IVIM MRI Images using a <strong>Bi-LSTM</strong> network.",
    results: [
            "SSIM score: 0.89-1.0",
            "Accepted for publication in the <strong>International Journal of Medical Engineering and Informatics (IJMEI)</strong>."
        ],
    repo: "https://github.com/abinshoby/IVIM-Image-Reconstruction",
  },
  {
    title: "Essense",
    date: "Aug 2018",
    description:
      "An AI-based search engine using a <strong>Bi-LSTM</strong> network that simplifies the query to obtain relevant results.",
    results: [
            "The search engine gave better search results using the simplified query."
        ],
    repo: "https://github.com/abinshoby/Essense",
  },
  {
    title: "Potential Fish Zone Visualisation",
    date: "Jul 2018",
    description:
      "Predicted and visualised potential fish zones using the <strong>Decision Tree</strong> algorithm.",
    results: [
            "First place for the Fischacken 2018 hackathon."
        ],
    repo: "https://github.com/abinshoby/fishing-zone-prediction-using-Decission-tree-algorithm",
    demo: "https://abinshoby.github.io/fizzit.github.io"
  },

  {
    title: "Automated Malayalam Question Suggestion using LSTM Networks",
    date: "Jul 2018",
    description:
      "A Malayalam question suggestion application was developed using <strong>LSTM</strong> networks.",
    results: [
            "Selected for the research poster presentation at the <strong>ACM Compute 2018</strong> conference."
        ],
    repo: "https://github.com/abinshoby/Auto-Suggestion-of-Malayalam-Question-using-LSTM",
  },
  {
    title: "Malayalam WordNet",
    date: "Jul 2018",
    description:
      "A Malayalam <strong> WordNet </strong> was constructed by scraping several websites using <strong>Python-selenium</strong>.",
    repo: "https://github.com/abinshoby/Malayalam-word-net",
  },
  {
    title: "Online AI-based Recruitment Platform",
    date: "Jul 2018",
    description:
      "An online campus recruitment platform was created using <strong>OpenCV</strong> and <strong>IBM Watson</strong> as a part of the Ideathon (2018) conducted at IIM, Kozhikode.",
    repo: "https://github.com/abinshoby/Online_Recruitment_Platform",
  },
  {
    title: "Speakzy",
    date: "Nov 2017",
    description:
      "A speech to text note taking <strong>Android application</strong> using <strong>Google Speech</strong> engine.",
    repo: "https://github.com/abinshoby/speakzy",
  }
];

export const skills = {
  languages: ["Python", "Java", "C", "C++", "PHP", "JavaScript", "TypeScript", "MySQL", "GraphQL", "CSS", "HTML"],
  tech: [
    "Artificial Intelligence",
    "Machine Learning",
    "Deep Learning",
    "Computer Vision",
    "Natural Language Processing",
    "Prompt Engineering",
    "Generative AI",
    "PyTorch",
    "TensorFlow",
    "Hugging Face Models",
    "OpenCV",
    "OpenAI API",
    "GPT-OSS",
    "LangChain",
    "Pydantic AI",
    "Agentic AI",
    "Scikit-learn",
    "Pandas",
    "Matplotlib",
    "Power BI",
    "Linux",
    "Docker",
    "AWS",
    "GCP",
    "Azure",
    "CI/CD",
    "IaaC",
    "DevOps",
    "Git",
    "Jira",
    "NodeJS",
    "REST API",
    "JSON API",
    "ReactJS",
    "NextJS",
    "Gatsby",
    "Bootstrap",
    "Drupal",
    "RAG"
  ],
  nonTech: [
    "Research",
    "Analysis",
    "Problem Solving",
    "Quick Learner",
    "Team Management",
    "Leadership",
    "Critical Thinking",
    "Professional Communication",
    "Agile Framework"
  ],
};

export const awards = [
  { title: "Winner of the GovHack hackathon, Australia", organisation: "The Australian Government", date: 2025 },
  { title: "Global Citizens Scholarship", organisation: "The University of Adelaide", date: 2024 },
  { title: "On the Spot Team Award", organisation: "TATA Consultancy Services", date: 2023 },
  { title: "Fourth Rank - Kickoff Hackathon", organisation: "TATA Consultancy Services", date: 2021 },
  { title: "Fresco Play Miles Award", organisation: "TATA Consultancy Services", date: 2021 },
  { title: "On the Spot (Team) Award", organisation: "TATA Consultancy Services", date: 2021 },
  { title: "Top 2% Rank", organisation: "APJ Abdul Kalam Technological University", date: 2020 },
  { title: "Top 11 - Bit a Byte of Code (Online Coding Challenge)", organisation: "School of AI, Trivandrum", date: 2019 },
  { title: "Top 19 - Codingo Coding Competition", organisation: "Coding Ninjas", date: 2019 },
  { title: "Excellent Score (91%) - Python Programming Certification Test", organisation: "Sanfoundry", date: 2019 },
  { title: "10/10 GPA - 4th & 8th Semesters", organisation: "APJ Abdul Kalam Technological University", date: "2018, 2020" },
  { title: "First Place - Fischacken Hackathon", organisation: "IEEE, TKM College of Engineering", date: 2018 },
  { title: "Top 7 Teams - Research Poster Presentation", organisation: "ACM Compute Conference", date: 2018 },
  { title: "Finalist - Microsoft AI Challenge", organisation: "Microsoft", date: 2018 },
  { title: "Best Coder - Mahawiki Coding Challenge", organisation: "Mahawiki", date: 2018 },
  { title: "Second Place - Zonal Level International Robotics League (IRL)", organisation: "IRL", date: 2016 }
];


export const contactRefs = [
  {
    name: "Dr Vu Minh Hieu Phan",
    position: "Research Scientist, Google, Sydney, Australia",
    email: "hieup007@gmail.com",
    relationship: "Internship Supervisor at Australian Institute for Machine Learning (AIML), Adelaide."
  },
  {
    name: "Mr Aniruddha Banerjee",
    position: "Project Manager, TCS",
    email: "ruddhani@gmail.com",
    relationship: "Project Manager at TATA Consultancy Services, India."
  },
];

export const misc = [
  {
    title: "Member",
    organization: "Australian Computer Society (ACS)",
    date: "2025-Present",
  },
  {
    title: "Mentor",
    organization: "<em>TKM College of Engineering, Kollam, India</em>",
    date: "2019-2020",
    details: [
      "Mentor for the <em>Machine Learning tutorial</em> organised by the <em>IEEE</em> student branch in the college."
    ]
  },
  {
    title: "Research Representative",
    organization: "<em>Computer Society of India (CSI), TKM College of Engineering, Kollam, India</em>",
    date: "2019-2020",
    details: ["Acted as the research representative of the CSI, TKMCE branch."]
  },
  {
    title: "Coordinator of Epoch",
    organization: "<em>TKM College of Engineering, Kollam, India</em>",
    date: "2019",
    details: [
      "Coordinated the online AI competition (Epoch) for the college tech fest."
    ]
  }
];
